var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('style',{tag:"component"},[_vm._v("\n  #main-scrolling { scrollbar-gutter: unset; }\n")])}
var staticRenderFns = []

export { render, staticRenderFns }